import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import formatDateLocal from "../../../services/formatDateLocal";
import RenderInputs from "../../../Components/Inputs";
import submitForm from "../../../services/submitForm";

export default function UpdateLenhSanXuat() {
  const {
    lang,
    pages,
    proxy,
    functions,
    database: { fields, tables },
  } = useSelector((state) => state);
  const { makeAutoIncreament } = functions;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setSubmit] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDisabled, setDisabled] = useState({
    soLuongCanSanXuatLSX: true,
    soLuongSanXuatDuLSX: true,
  });
  const [isChecked, setIsChecked] = useState({
    soLuongCanSanXuatLSX: false,
    soLuongSanXuatDuLSX: false,
  });
  const [inputFields, setInputFields] = useState([
    {
      name: "Mã Lệnh Sản Xuất",
      alias: "lenhSanXuatLSX",
      type: "text",
      required: true,
      readOnly: true,
    },
    {
      name: "Mã Thành Phẩm",
      // alias: "maThanhPhamLSX",
      alias: "DanhSachSP",
      table_id: 21692,
      type: "select",
      required: true,
      displayFields: ["22MSP", "10TSP"],
      isPK: "22MSP",
      isMulti: true,
      isClone: false,
    },
    {
      name: "Số Lượng Cần Sản Xuất (Tấn)",
      alias: "soLuongCanSanXuatLSX",
      type: "float",
      col: "col-md-6 offset-md-2",
      isCheckbox: true,
    },
    {
      name: "Số Lượng Sản Xuất Dư",
      alias: "soLuongSanXuatDuLSX",
      type: "number",
      col: "col-md-2",
    },
    {
      name: "Thời Gian Bắt Đầu",
      alias: "thoiGianBatDauLSX",
      type: "datetime-local",
      required: true,
      col: "col-md-6 offset-md-2",
    },
    {
      name: "Thời Gian Kết Thúc",
      alias: "thoiGianKetThucLSX",
      type: "datetime-local",
      col: "col-md-2",
      required: true,
    },
    {
      name: "Số LOT",
      alias: "soLotLSX",
      type: "text",
      required: true,
      // col: "col-md-6 offset-md-3",
      child: [
        {
          name: "Mã Ký Hiệu",
          alias: "maKyHieuLSX",
          type: "input-select",
          table_id: 3663535,
          displayFields: ["maKyHieuLOT"],
          style: {
            borderRadius: "0 .25rem 0 0",
            borderLeft: "0px",
          },
          isPK: "maKyHieuLOT",
        },
      ],
    },
    // {
    //   name: "Mã tổ chức kho",
    //   alias: "maToChucKhoLSX",
    //   type: "select",
    //   required: true,
    //   displayFields: ["2MLK", "7LK"],
    //   table_id: 21715,
    //   isPK: "2MLK",
    // },
    {
      name: "Kho Nhập",
      alias: "khoNhapLSX",
      type: "select",
      required: true,
      displayFields: ["11MK", "4TK"],
      table_id: 21719,
      isPK: "11MK",
    },
    {
      name: "Chứng Từ KCS",
      alias: "chungTuKCSLSX",
      type: "file",
    },
    {
      name: "Ghi Chú",
      alias: "ghiChuLSX",
      type: "textarea",
    },
  ]);

  const _token = localStorage.getItem("_token");
  const param = useParams();

  const [watchNSX, watchLotId, watchMaKyHieu] = watch([
    "thoiGianBatDauLSX",
    "soLotLSX",
    "maKyHieuLSX",
  ]);

  useEffect(() => {
    if (watchNSX) {
      const lastDayOfMonth = moment(watchNSX)
        .endOf("month")
        .format("yyyy-MM-DDTHH:mm");
      setValue("thoiGianKetThucLSX", lastDayOfMonth);

      const lotId = moment(watchNSX).format("YYYY.MM.");

      const currentLotId = !watchLotId ? lotId : watchLotId.split(/[A-Z]+$/)[0];

      const newSoLot = currentLotId + (watchMaKyHieu || "");

      setValue("soLotLSX", newSoLot);
    }
  }, [watchNSX, watchMaKyHieu]);

  useEffect(() => {
    const tableId = 3986052;
    const api_id = [];

    pages
      .filter(({ is_hidden }) => !is_hidden)
      .forEach((page) => {
        page.children
          .filter(({ is_hidden }) => !is_hidden)
          .forEach((child) => {
            child.component.forEach((item) => {
              const { props } = item;
              const findId = props.source?.tables?.find(
                (item) => item.id === tableId
              );
              if (findId) {
                const currentPage = pages.find((p) => p.block === item.id)
                  ?.component?.[0]?.children;

                if (currentPage) {
                  const mappedFields = currentPage
                    .map((item) => {
                      const {
                        props: {
                          variable_name,
                          title: { content, visible },
                          required,
                          displayField,
                          betChar,
                          textarea,
                        },
                      } = item;
                      if (!visible) return null;

                      const field = inputFields.find(
                        ({ alias }) => alias === variable_name
                      );

                      if (field) {
                        return {
                          ...field,
                          name: content,
                          alias: variable_name,
                          type: textarea ? "textarea" : field.type,
                          required,
                          betChar,
                          displayFields:
                            displayField && displayField.length
                              ? displayField?.map(({ value }) => value)
                              : field.displayFields,
                        };
                      }
                    })
                    .filter(Boolean);
                  setInputFields(mappedFields);
                }
                setTables(findId);
                api_id.push(props?.buttons?.add?.api?.api_id);
              }
            });
          });
      });

    fetch(`${proxy()}/apis/api/${api_id?.[0]}/input_info`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data) setDefaultValues(data.display_fields);
      });
  }, [pages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(proxy() + `/api/LSX/${param.id}`, {
          headers: {
            Authorization: _token,
            "content-type": "application/json",
          },
        });
        const res = await response.json();
        const { success, data, message } = res;

        if (success && data) {
          const selectedValuesTemp = {};

          for (const item of inputFields) {
            // if (data[item.alias]) {
            const opts = [];
            const table_id = item?.table_id;
            const { betChar, isPK } = item;
            if (item.child) {
              for (const child of item.child) {
                const table_id = child?.table_id;
                if (table_id) {
                  const foreignResponse = await ForeignData_API.get(
                    proxy(),
                    _token,
                    { table_id }
                  );
                  const { data: foreignData = [] } = foreignResponse;

                  if (foreignData.length) {
                    foreignData.forEach((item) => {
                      const fields = child?.displayFields?.map(
                        (field) => item[field]
                      );
                      // opts.push({ label: fields.join("_"), value: fields[0] });
                      opts.push({
                        label: fields.join(betChar ? betChar : " | "),
                        value: item[child.isPK],
                      });
                    });

                    setValue(child.alias, data[child.alias]);
                  }
                }
              }
              setOptions(opts);
            }

            if (item.type === "select" || item.type === "input-select") {
              let dataBody = {
                table_id,
                start_index: 0,
                type: "or",
              };

              dataBody["criteria"] = { [isPK]: data[item.alias] };
              dataBody["criteria_type"] = { [item.alias]: "regex" };

              const foreignResponse = await ForeignData_API.get(
                proxy(),
                _token,
                dataBody
              );
              const { data: foreignData = [] } = foreignResponse;
              if (foreignData.length) {
                const result = foreignData.reduce((acc, curr) => {
                  const checkEmpty = Array.isArray(data[item.alias])
                    ? data[item.alias].some((item) => item === curr[isPK])
                    : curr[isPK] === data[item.alias];

                  if (checkEmpty) {
                    const fields = item?.displayFields?.map(
                      (field) => curr[field]
                    );

                    opts.push({
                      label: fields.join(betChar ? betChar : " | "),
                      value: curr[isPK],
                    });
                    // if (fields.some((field) => field === data[item.alias])) {

                    selectedValuesTemp[item?.alias] = {
                      label: fields.join(betChar ? betChar : " | "),
                      value: curr[isPK],
                    };

                    acc.push({
                      label: fields.join(betChar ? betChar : " | "),
                      value: curr[isPK],
                    });
                  }
                  // }
                  return acc;
                }, []);

                if (result.length) {
                  setSelectedValues((prev) => ({
                    ...prev,
                    [item?.alias]: item?.isMulti ? result : result?.[0],
                  }));
                }
              }
            } else if (item.type === "input-select") {
              setOptions(opts);
            } else {
              const formattedData = formatDateLocal(
                data[item.alias],
                item.type
              );
              setValue(item.alias, formattedData);
            }

            // }
          }
        } else {
          Swal.fire({
            title: lang["error"] || "Error",
            text: message,
            icon: "error",
            showConfirmButton: true,
            confirmButtonText: "OK",
            allowOutsideClick: false,
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              navigate(-1);
            }
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [inputFields]);

  const onSubmit = async (data) => {
    for (const property in data) {
      if (selectedValues[property]) {
        data = {
          ...data,
          [property]: Array.isArray(selectedValues[property])
            ? selectedValues[property].map((item) => item.value)
            : selectedValues[property]?.value || "",
        };
      }
    }
    const trimmedData = Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
    const mappedData = {
      data: trimmedData,
      default_field_value: defaultValues,
      table: isTables,
    };

    await submitForm({
      url: `/api/LSX/${param.id}`,
      method: "PUT",
      data: mappedData,
      proxy,
      lang,
      inputFields,
    });
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => navigate(-1)}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        Lệnh Sản Xuất
                        <i className="fa fa-chevron-right ml-2 mr-1" />
                        {lang["update"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  {loading ? (
                    <img
                      width={40}
                      className="loading-image"
                      src="/images/icon/load.gif"
                      alt="Loading..."
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                      }}
                    />
                  ) : (
                    <div className="col-md-12">
                      <div
                        style={{
                          height: "70vh",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <div className="row w-50-pct mg-auto p-1 bg-white input-put">
                          {inputFields.map((field, index) => {
                            const {
                              required,
                              name,
                              alias,
                              col,
                              child,
                              style,
                              isHiden,
                              isCheckbox,
                            } = field;
                            return (
                              !isHiden && (
                                <>
                                  <div
                                    className={`${
                                      col ? col : `col-sm-8  offset-sm-2`
                                    } mb-3`}
                                    style={style}
                                  >
                                    {isCheckbox && (
                                      <input
                                        class="form-check-input ml-0"
                                        type="checkbox"
                                        value={isChecked?.[alias]}
                                        checked={isChecked?.[alias]}
                                        onChange={(e) => {
                                          const { checked } = e.target;
                                          setDisabled((prev) => ({
                                            ...prev,
                                            soLuongCanSanXuatLSX:
                                              !prev["soLuongCanSanXuatLSX"],
                                            soLuongSanXuatDuLSX:
                                              !prev["soLuongSanXuatDuLSX"],
                                          }));

                                          if (!checked) {
                                            setValue(
                                              "soLuongCanSanXuatLSX",
                                              ""
                                            );
                                            setValue("soLuongSanXuatDuLSX", "");
                                          }

                                          setIsChecked((prev) => ({
                                            ...prev,
                                            soLuongCanSanXuatLSX:
                                              !prev["soLuongCanSanXuatLSX"],
                                            soLuongSanXuatDuLSX:
                                              !prev["soLuongSanXuatDuLSX"],
                                          }));
                                        }}
                                        id={alias}
                                      />
                                    )}
                                    <div {...register(alias)}>
                                      <label
                                        class={`${
                                          isCheckbox && `ml-4`
                                        } form-label`}
                                        // for={alias}
                                      >
                                        {name}
                                        {required && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </label>
                                      <div
                                        className={
                                          child && child.length && `input-group`
                                        }
                                      >
                                        <RenderInputs
                                          control={control}
                                          register={register}
                                          selectedValues={selectedValues}
                                          setSelectedValues={setSelectedValues}
                                          field={field}
                                          options={options}
                                          setValue={setValue}
                                          getValues={getValues}
                                          isDisabled={isDisabled}
                                          setDisabled={setDisabled}
                                        />
                                        {child &&
                                          child.map((item) => (
                                            <div className="input-group-append">
                                              <RenderInputs
                                                control={control}
                                                register={register}
                                                selectedValues={selectedValues}
                                                setSelectedValues={
                                                  setSelectedValues
                                                }
                                                field={item}
                                                options={options}
                                                setValue={setValue}
                                                getValues={getValues}
                                                isChild={true}
                                                isDisabled={isDisabled}
                                                setDisabled={setDisabled}
                                              />
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )
                            );
                          })}
                        </div>
                      </div>
                      <div className="col-sm-7 offset-sm-3 p-0">
                        <div className="d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-success mr-2"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => setSubmit(true)}
                          >
                            Lưu lại
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger"
                            style={{
                              minWidth: "105px",
                            }}
                            onClick={() => navigate(-1)}
                          >
                            Đóng
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
